import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Type} from "bukku/redux/Transaction/helper";
import LinkAccess from "../Access/LinkAccess";
import {getInitFinancialYear} from "../../containers/AppPage/Stock/Values/getInitFinancialYear";
import dayjs from 'dayjs';
import {getWebBaseUrl} from "../../redux/Transaction/helpers/getWebBaseUrl";
import {TransactionUrl} from "../../redux/Transaction/helpers/TransactionUrl";

class TransactionLink extends Component {
    getUrl = () => {
        const { transaction, fyEndMonth } = this.props;

        if (!transaction.type || !transaction.id)
            return null;

        if (transaction.type === Type.stock_value) {
            const financialYear = transaction.date ?
                getInitFinancialYear(fyEndMonth, dayjs(transaction.date)) : getInitFinancialYear(fyEndMonth);

            const webUrl = getWebBaseUrl(transaction.type, true);
            return financialYear ? `${webUrl}?financial_year=${financialYear}` : '';
        }

        return TransactionUrl.view(transaction.type, transaction.id);
    };

    render() {
        const {
            label,
            newWindow,
        } = this.props;
        const url = this.getUrl();

        if (url)
            return <LinkAccess to={this.getUrl()} newWindow={newWindow}>{ label }</LinkAccess>;
        return label || null;
    }
}
export default connect(state => ({
    fyEndMonth: state.List.settings?.financial_year_end_month,
}), {
    //
})(TransactionLink);
